// extracted by mini-css-extract-plugin
module.exports = {"labelValue":"labelValue_labelValue__3wsdc","label":"labelValue_label__396wy","value":"labelValue_value__1kwKI"};